// extracted by mini-css-extract-plugin
export default {"root":"Switcher_root__ygaVh","rootActive":"Switcher_rootActive__YQ0Tl","circle":"Switcher_circle__Vi8rL"};